import React, { useEffect, useRef, useState } from "react"
import { useSearchParams } from "../../../../hooks/useSearchParams"
import { useParams } from "react-router-dom"
import useToggle from "../../../../hooks/toggle"
import { selecteddocumentesign } from "../ReviewDocs"
import Esign from "../Esign"
import { useSelector } from "react-redux"
import { useReactToPrint } from 'react-to-print';
import { ALAsaverelease, getexternaldocuments, getSavedOfferDetails } from "../../../../api/transaction"
import { CSpinner } from "@coreui/react"
const ALAreleasefrompurchase= ()=>{

  const {id,user}:any = useParams()
  const componentRef = useRef();
  const [loader,setloading] = useState(false)
const [releasepurchase,setReleasePurchase] = useState({
  offer_id :id,
  property_located_at :"",
    buyer_agreement_date :null,
    buyer_address :"",
    buyer_authorize_address :"",
    buyer_amount_of:"",
    buyer_return_to_buyer :false,
    buyer_return_to_seller :false,
    buyer_return_to_anonymous :false,
    buyer_release_buyer_mail_check_to :"",
    buyer_release_seller_mail_check_to :"",
    buyer_release_anonymous_mail_check_to :"",
    buyer1_signature :"",
    buyer1_signature_date :null,
    buyer2_signature :"",
    buyer2_signature_date :null,

    seller_agreement_date :null,
    seller_address :"",
    seller_authorize_address :"",
    seller_amount_of :"",
    seller_return_to_buyer :false,
    seller_return_to_seller :false,
    seller_return_to_anonymous: false,
    seller_release_buyer_mail_check_to :"",
    seller_release_seller_mail_check_to:"",
    seller_release_anonymous_mail_check_to :"",
    seller1_signature :"",
    seller1_signature_date :"",
    seller2_signature :"",
    seller2_signature_date :""
  
})

const [canvasmodal, setCanvasModal] = useToggle(false);
const [htmlContent, setHtmlContent] = useState("");
const [offerdetails, setOfferDetails] = useState({});
const [selecteddocumentesign, setselectedDocumentEsign] = useState<selecteddocumentesign>({
    offerid: "",
    document_name: "",
    image_base64: "",
    sign_role: 1
})
// @ts-ignore
const val = useSelector((state) => state?.new?.signset)
//   const seller_date = ()=>{const d =  new Date();setLeadBasePaint({...leadbasepaint,seller1_date: new Date()})  }


const printf = async () => {
    // window.print()
    handlePrint()
}



useEffect(()=>{
  if(val){
    if(user == "seller"){
      setReleasePurchase({ ...releasepurchase,seller1_signature: val  }) 
    }
    if(user == "client"){
      setReleasePurchase({ ...releasepurchase,buyer1_signature: val  }) 
    }
  }
  },[val])

const send = async () => {
  setloading(true)
  if(user === "seller"){

    if(releasepurchase?.seller1_signature){
      let res = await ALAsaverelease(releasepurchase)
      if(res?.status == "success"){
        alert("Submitted Successfully")
    }
    else{
        alert("Something went wrong")
    }
    }
  }
  else if(user === "client"){
    
    if(releasepurchase?.buyer1_signature){
      let res = await ALAsaverelease(releasepurchase)
      if(res?.status == "success"){
        alert("Submitted Successfully")
    }
    else{
        alert("Something went wrong")
    }
    }
  }
  else{
    let res = await ALAsaverelease(releasepurchase)
    if(res?.status == "success"){
      alert("Submitted Successfully")
  }
  else{
      alert("Something went wrong")
  }
  }
  setloading(false)
}

useEffect(()=>{
  (async function(){
    let offerdetails = await getSavedOfferDetails(id)
    setOfferDetails(offerdetails[0])
    const res =await getexternaldocuments(id,"releasepurchase") 
    setReleasePurchase({...releasepurchase,
      property_located_at :res?.data?.property_located_at,
      
        buyer_agreement_date :res?.data?.buyer_agreement_date,
        buyer_address :res?.data?.buyer_address,
        buyer_authorize_address :res?.data?.buyer_authorize_address,
        buyer_amount_of:res?.data?.buyer_amount_of,
        buyer_return_to_buyer :res?.data?.buyer_return_to_buyer,
        buyer_return_to_seller :res?.data?.buyer_return_to_seller,
        buyer_return_to_anonymous :res?.data?.buyer_return_to_anonymous,
        buyer_release_buyer_mail_check_to :res?.data?.buyer_release_buyer_mail_check_to,
        buyer_release_seller_mail_check_to :res?.data?.buyer_release_seller_mail_check_to,
        buyer_release_anonymous_mail_check_to :res?.data?.buyer_release_anonymous_mail_check_to,
        buyer1_signature :res?.data?.buyer1_signature,
        buyer1_signature_date :res?.data?.buyer1_signature_date,
        buyer2_signature :res?.data?.buyer2_signature,
        buyer2_signature_date :res?.data?.buyer2_signature_date,
    
      
        seller_agreement_date :res?.data?.seller_agreement_date,
        seller_address :res?.data?.seller_address,
        seller_authorize_address :res?.data?.seller_authorize_address,
        seller_amount_of :res?.data?.seller_amount_of,
        seller_return_to_buyer :res?.data?.seller_return_to_buyer,
        seller_return_to_seller :res?.data?.seller_return_to_seller,
        seller_return_to_anonymous: res?.data?.seller_return_to_anonymous,
        seller_release_buyer_mail_check_to :res?.data?.seller_release_buyer_mail_check_to,
        seller_release_seller_mail_check_to:res?.data?.seller_release_seller_mail_check_to,
        seller_release_anonymous_mail_check_to :res?.data?.seller_release_anonymous_mail_check_to,
        seller1_signature :res?.data?.seller1_signature,
        seller1_signature_date :res?.data?.seller1_signature_date,
        seller2_signature :res?.data?.seller2_signature,
        seller2_signature_date :res?.data?.seller2_signature_date,
      
    })
  })()
},[])


const handlePrint = useReactToPrint({
  content: () => componentRef.current,
});
    return(
        <>
        <table
  style={{ width: 1100, margin: "0 auto", background: "#fff", padding: 15 }} ref={componentRef}
>
  <tbody>
    <tr>
      <td>
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td style={{ width: "90%" }}>
                <img
                  style={{ width: 250 }}
                  src="https://storagemilforddev.blob.core.windows.net/images/logo.svg"
                />
              </td>
              <td>
                <img
                  style={{ width: 30 }}
                  src="https://storagemilforddev.blob.core.windows.net/images/realtor.svg"
                  alt=""
                />
                <img
                  style={{ width: 50 }}
                  src="https://storagemilforddev.blob.core.windows.net/images/eh.svg"
                  alt=""
                />
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td>
        <span style={{ fontSize: 20, fontWeight: 700 }}>
          Release from Purchase Agreement
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px" }}>
        <span>
          (This is a legally binding contract. If not understood, seek legal
          advice.)
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px" }}>
        <span>
          Regarding Property Located At:
          <input
            type="text"//@ts-ignore
            value={offerdetails?.propertyAddress}
            // onChange={(e)=>setReleasePurchase({...releasepurchase,property_located_at:e.target.value})}
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: 100
            }}
          />
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px" }}>
        <span style={{ fontWeight: 600 }}>BUYER(S) RELEASE</span>
      </td>
    </tr>
    <tr>
      <td>
        <span>
          I/we, the undersigned, hereby request to be released from the Purchase
          Agreement dated{" "}
          <input
            type="date"
            value={releasepurchase?.buyer_agreement_date}
            onChange={(e) =>
              setReleasePurchase({
                ...releasepurchase,
               
                  buyer_agreement_date: e.target.value,
                
              })
            }
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: 200
            }}
          />
          which includes the property described above.
        </span>
      </td>
    </tr>
    <tr>
      <td>
        <span>
          I/we release and hold harmless Milford Real Estate and its agents, the
          Seller(s), and{" "}
          <input
            type="text" 
            value={releasepurchase?.buyer_address}
            onChange={(e) =>
              setReleasePurchase({
                ...releasepurchase,
                  buyer_address: e.target.value,
              
              })
            }
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: 200
            }}
          />
          (Title/Escrow Co.) from any and all liability, obligation, claims or
          damages in connection with this transaction. This includes but is not
          limited to the Buyer(s) not filing any complaints or law suits with
          any organizations or courts.
        </span>
      </td>
    </tr>
    <tr>
      <td>
        <span>
          I/we authorize
          <input
            type="text"
            value={releasepurchase?.buyer_authorize_address}
            onChange={(e) =>
              setReleasePurchase({
                ...releasepurchase,
                  buyer_authorize_address: e.target.value,
              
              })
            }
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: 200
            }}
          />
          (Title/Escrow Co.) to distribute the earnest deposit in the amount of
          ${" "}
          <input
            type="text"
            value={releasepurchase?.buyer_amount_of}
            onChange={(e) =>
              setReleasePurchase({
                ...releasepurchase,
                  buyer_amount_of: e.target.value,
              
              })
            }
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: 200
            }}
          />{" "}
          in the following manner:
        </span>
      </td>
    </tr>
    <tr>
      <td>
        <span>
          {/* <input type="checkbox" 
            checked={releasepurchase?.buyer_return_to_buyer}
            onChange={(e) =>
              setReleasePurchase({
                ...releasepurchase,
                  buyer_return_to_buyer: !releasepurchase?.buyer_return_to_buyer,
              
              })
            }/> */}
          {/* RETURN TO BUYER(S). Mail check to:
          <input
            type="text"
            value={releasepurchase?.buyer_release_buyer_mail_check_to}
            onChange={(e) =>
              setReleasePurchase({
                ...releasepurchase,
                  buyer_release_buyer_mail_check_to: e.target.value,
              
              })
            }
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "70%"
            }}
          /> */}
        </span>
      </td>
    </tr>
    <tr>
      <td>
        <span>
          <input type="checkbox"
             checked={releasepurchase?.buyer_return_to_seller} 
           onChange={(e) =>
            setReleasePurchase({
              ...releasepurchase,
                buyer_return_to_seller: !releasepurchase?.buyer_return_to_seller,
              
            })
          }
          />
          RETURN TO BUYER(S). Mail check to:
          <input
            type="text"
            value={releasepurchase?.buyer_release_seller_mail_check_to}
            onChange={(e) =>
              setReleasePurchase({
                ...releasepurchase,
                  buyer_release_seller_mail_check_to: e.target.value,
                
              })
            }
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "70%"
            }}
          />
        </span>
      </td>
    </tr>
    <tr>
      <td>
        <span>
          <input type="checkbox" 
           checked={releasepurchase?.buyer_return_to_anonymous} 
           onChange={(e) =>
            setReleasePurchase({
              ...releasepurchase,
                buyer_return_to_anonymous: !releasepurchase?.buyer_return_to_anonymous,
              
            })
          }
          />
          <input
            type="text"
            value={releasepurchase?.buyer_release_anonymous_mail_check_to}
            onChange={(e) =>
              setReleasePurchase({
                ...releasepurchase,
                  buyer_release_anonymous_mail_check_to: e.target.value,
                
              })
            }
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "95%"
            }}
          />
          {/* <input
            type="text"
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "100%"
            }}
          />{" "} */}
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px" }}>
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td>
                <span>
                  <img
                   
                    src={user==="client" ? (val ||releasepurchase?.buyer1_signature) : releasepurchase?.buyer1_signature}
                    // onChange={(e) =>
                    //   setReleasePurchase({
                    //     ...releasepurchase,
                    //     buyer_release: {
                    //       ...releasepurchase?.buyer_release,
                    //       buyer1_signature: e.target.value,
                    //     },
                    //   })
                    // }
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid #3b0083",
                      width: "100px"
                    }}
                  />
                </span>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "100%" }}>
                        <span>Buyer </span>
                      </td>
                      <td>
                        <input type="date" 
                            value={releasepurchase?.buyer1_signature_date ? releasepurchase?.buyer1_signature_date : (user === "client" && val || releasepurchase?.buyer1_signature) ? new Date().toISOString().split('T')[0] : ""}
                            onChange={(e) =>
                              setReleasePurchase({
                                ...releasepurchase,
                                  buyer1_signature_date: e.target.value,
                                
                              })
                            }
                        />
                        
                        date/time</td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td>
                <span>
                  <input
                    type="text"
                    value={releasepurchase?.buyer2_signature}
                            onChange={(e) =>
                              setReleasePurchase({
                                ...releasepurchase,
                                  buyer2_signature: e.target.value,
                              
                              })
                            }
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid #3b0083",
                      width: "100px"
                    }}
                  />
                </span>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "100%" }}>
                        <span>Buyer </span>
                      </td>
                      <td>
                      <input type="date" 
                            value={releasepurchase?.buyer2_signature_date}
                            onChange={(e) =>
                              setReleasePurchase({
                                ...releasepurchase,
                                  buyer2_signature_date: e.target.value,
                              
                              })
                            }
                        />
                        date/time</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px" }}>
        <span style={{ fontWeight: 600 }}>SELLER(S) RELEASE</span>
      </td>
    </tr>
    <tr>
      <td>
        <span>
          I/we, the undersigned, hereby request to be released from the Purchase
          Agreement dated{" "}
          <input
            type="date"
            value={releasepurchase?.seller_agreement_date}
            onChange={(e) =>
              setReleasePurchase({
                ...releasepurchase,
                  seller_agreement_date: e.target.value,
              
              })
            }
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: 200
            }}
          />
          which includes the property described above.
        </span>
      </td>
    </tr>
    <tr>
      <td>
        <span>
          I/we release and hold harmless Milford Real Estate and its agents, the
          Seller(s), and{" "}
          <input
            type="text"
            value={releasepurchase?.seller_address}
            onChange={(e) =>
              setReleasePurchase({
                ...releasepurchase,
                  seller_address: e.target.value,
              
              })
            }
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: 200
            }}
          />
          (Title/Escrow Co.) from any and all liability, obligation, claims or
          damages in connection with this transaction. This includes but is not
          limited to the Buyer(s) not filing any complaints or law suits with
          any organizations or courts.
        </span>
      </td>
    </tr>
    <tr>
      <td>
        <span>
          I/we authorize
          <input
            type="text"
            value={releasepurchase?.seller_authorize_address}
            onChange={(e) =>
              setReleasePurchase({
                ...releasepurchase,
                  seller_authorize_address: e.target.value,
              
              })
            }
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: 200
            }}
          />
          (Title/Escrow Co.) to distribute the earnest deposit in the amount of
          ${" "}
          <input
            type="text"
            value={releasepurchase?.seller_amount_of}
            onChange={(e) =>
              setReleasePurchase({
                ...releasepurchase,
                  seller_amount_of: e.target.value,
              
              })
            }
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: 200
            }}
          />{" "}
          in the following manner:
        </span>
      </td>
    </tr>
    {/* <tr>
      <td>
        <span>
          <input type="checkbox" 
              checked={releasepurchase?.seller_return_to_buyer}
              onChange={(e) =>
                setReleasePurchase({
                  ...releasepurchase,
                    seller_return_to_buyer: !releasepurchase?.seller_return_to_buyer,
                
                })
              }
          />
          RETURN TO BUYER(S). Mail check to:
          <input
            type="text"
            value={releasepurchase?.seller_release_buyer_mail_check_to}
            onChange={(e) =>
              setReleasePurchase({
                ...releasepurchase,
                  seller_release_buyer_mail_check_to: e.target.value,
                
              })
            }
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "70%"
            }}
          />
        </span>
      </td>
    </tr> */}
    <tr>
      <td>
        <span>
          <input type="checkbox" 
            checked={releasepurchase?.seller_return_to_seller}
            onChange={(e) =>
              setReleasePurchase({
                ...releasepurchase,
                  seller_return_to_seller: !releasepurchase?.seller_return_to_seller,
              
              })
            }/>
          RETURN TO BUYER(S). Mail check to:
          <input
            type="text"
            value={releasepurchase?.seller_release_seller_mail_check_to}
            onChange={(e) =>
              setReleasePurchase({
                ...releasepurchase,
                  seller_release_seller_mail_check_to: e.target.value,
                
              })
            }
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "70%"
            }}
          />
        </span>
      </td>
    </tr>
    <tr>
      <td>
        <span>
          <input type="checkbox" 
           checked={releasepurchase?.seller_return_to_seller}
           onChange={(e) =>
             setReleasePurchase({
               ...releasepurchase,
                 seller_return_to_seller: !releasepurchase?.seller_return_to_seller,
               
             })
           }
          />
          <input
            type="text"
            value={releasepurchase?.seller_release_anonymous_mail_check_to}
            onChange={(e) =>
              setReleasePurchase({
                ...releasepurchase,
                  seller_release_anonymous_mail_check_to: e.target.value,
              
              })
            }
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "95%"
            }}
          />
          {/* <input
            type="text"
            style={{
              outline: "none",
              border: "none",
              borderBottom: "1px solid black",
              width: "100%"
            }}
          />{" "} */}
        </span>
      </td>
    </tr>
    <tr>
      <td style={{ padding: "15px 0px" }}>
        <table style={{ width: "100%" }}>
          <tbody>
            <tr>
              <td>
                <span>
                  <img
                   
                    src={user==="seller" ? (val ||releasepurchase?.seller1_signature) : releasepurchase?.seller1_signature}
                   
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid #3b0083",
                      width: "100px"
                    }}
                  />
                </span>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "100%" }}>
                        <span>Seller </span>
                      </td>
                      <td>
                      <input
                    type="date"
                    value={releasepurchase?.seller1_signature_date ? releasepurchase?.seller1_signature_date : (user === "seller" && val || releasepurchase?.seller1_signature) ? new Date().toISOString().split('T')[0] : ""}
                    onChange={(e) =>
                      setReleasePurchase({
                        ...releasepurchase,
                          seller1_signature_date: e.target.value,
                        
                      })
                    }
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid #3b0083",
                      width: "99%"
                    }}
                  />
                        date/time</td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td>
                <span>
                  <input
                    type="text"
                    value={releasepurchase?.seller2_signature}
                    onChange={(e) =>
                      setReleasePurchase({
                        ...releasepurchase,
                          seller2_signature: e.target.value,
                        
                      })
                    }
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid #3b0083",
                      width: "99%"
                    }}
                  />
                </span>
                <table style={{ width: "100%" }}>
                  <tbody>
                    <tr>
                      <td style={{ width: "100%" }}>
                        <span>seller </span>
                      </td>
                      <td>
                      <input
                    type="date"
                    value={releasepurchase?.seller2_signature_date}
                    onChange={(e) =>
                      setReleasePurchase({
                        ...releasepurchase,
                          seller2_signature_date: e.target.value,
                      
                      })
                    }
                    style={{
                      outline: "none",
                      border: "none",
                      borderBottom: "1px solid #3b0083",
                      width: "99%"
                    }}
                  />
                        date/time</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </td>
    </tr>
    <tr>
      <td style={{ paddingTop: 200 }}>
        <span>
          Other provisions: Earnest deposit to be delivered within (5) business
          days.
        </span>
      </td>
    </tr>
  </tbody>
</table>
<React.Fragment>
<div className="d-flex align-items-center justify-content-end mb-2 mr-2">
    <button onClick={send} className="btn primaryColorBtn">Submit
    {loader && <CSpinner color="dark" size="sm" className={'ml-1'} />}
    </button>
    <button onClick={printf} className="btn print-doc-btn mx-2">Print</button>
    <button className="signaturebtn btn mb-0" onClick={() => setCanvasModal()}>Signature</button> 
</div>
          </React.Fragment>
            <Esign
                canvasmodal={canvasmodal}
                setCanvasModal={setCanvasModal}
                htmlContent={htmlContent}
                setHtmlContent={setHtmlContent}
                selecteddocumentesign={selecteddocumentesign}
                setselectedDocumentEsign={setselectedDocumentEsign}
                type={"seller"}
            ></Esign>
        </>
    )
}

export default ALAreleasefrompurchase